import AmioHttpService from './amio-http.service'

class ChatThemeService extends AmioHttpService {
  async create({ name = 'New theme', themeConfig = {}, langConfig = {} }) {
    const { data } = await this.requestPost('/chat-themes', {
      name,
      themeConfig,
      langConfig
    })

    return this._adaptData(data)
  }

  async list() {
    const { data } = await this.requestGet('/chat-themes')
    return data.map(this._adaptData)
  }

  async update({ id, themeConfig = {}, langConfig = {}, name }) {
    const { data } = await this.requestPatch(`/chat-themes/${id}`, {
      name,
      themeConfig,
      langConfig
    })

    return this._adaptData(data)
  }

  async delete(chatThemeId) {
    return this.requestDelete(`/chat-themes/${chatThemeId}`)
  }

  async get(chatThemeId) {
    const { data } = await this.requestGet(`/chat-themes/${chatThemeId}`)
    return this._adaptData(data)
  }

  _adaptData(data) {
    return {
      id: data?.id,
      name: data.name,
      themeConfig: data.theme_config,
      langConfig: data.lang_config
    }
  }
}

export default new ChatThemeService()
